import { Grid, TextField } from '@mui/material';
import React, { useMemo } from 'react';
import { PostcodeSearch } from '../../../Clients/AddressTab/PostcodeSearch';
import { ILegalTransactionRelationshipRealEstate } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { IPostcode } from '../../../Interfaces/IPostcode';

interface IProps {
  formValues: ILegalTransactionRelationshipRealEstate;
  setFormValues: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationshipRealEstate>
  >;
  disableRequiremend?: boolean;
}

/**
 * Reine Adresseingabe (Straße/Hausnummer/PLZ). Koordinaten und die
 * Adress-/Koordinatensuche wurden entfernt — die Lage wird auf der Karte
 * automatisch aus der Adresse ermittelt (bzw. exakt via BORIS im Grundbuch-Tab).
 */
export const RealEstateAddress: React.FC<IProps> = ({
  formValues: { Street, StreetAditional, StreetNr, idPostcode, Postcode, City },
  setFormValues,
  disableRequiremend,
}) => {
  const isRequired =
    disableRequiremend === undefined || disableRequiremend === false;

  const postcodeObject: IPostcode | undefined = useMemo(
    () =>
      City && Postcode && idPostcode && idPostcode > 0
        ? {
            idPostcode: idPostcode,
            Postcode: Postcode,
            City: City,
            idCountry: 1,
          }
        : undefined,
    [idPostcode, Postcode, City]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5}>
        <TextField
          label='Straße'
          size='small'
          required={isRequired}
          fullWidth
          value={Street ?? ''}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              Street: target.value || null,
            }))
          }
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <TextField
          label='Adresszusatz'
          size='small'
          fullWidth
          value={StreetAditional ?? ''}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              StreetAditional: target.value || null,
            }))
          }
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          label='Hausnummer'
          size='small'
          required={isRequired}
          fullWidth
          value={StreetNr ?? ''}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              StreetNr: target.value || null,
            }))
          }
        />
      </Grid>
      <Grid item xs={12}>
        <PostcodeSearch
          key={JSON.stringify(postcodeObject)} // Re-render bei geänderten Werten
          postcodeObject={postcodeObject}
          required={isRequired}
          updatePostcodeObject={newValue =>
            setFormValues(x => ({
              ...x,
              idPostcode: newValue?.idPostcode ?? null,
              Postcode: newValue?.Postcode ?? undefined,
              City: newValue?.City || undefined,
            }))
          }
        />
      </Grid>
    </Grid>
  );
};
